<template>
    <v-container class="text-left">
      <v-row>
        <v-col>
          <h2>회사 소개</h2>
          <p>
            오늘날의 물류산업은 단순한 운송만을 제공하는 것이 아니라 재화와 용역의 흐름을 종합하는 TOTAL LOGISTICS 개념으로 서비스를 제공합니다.
          </p>
          <p>
            재화와 용역의 세부적인 운송에는 글로벌 시대의 전자 상거래 제품, 구매대행, 배송대행, 대용량 컨테이너 운송과 관련된 주재원 귀국 이사화물, 유학생 소량 이삿짐, 자동차 운송, 카라반 운송, 안틱가구 운송, 전시품 등이 목적지에 도착 후 수하인에게 안전하게 양도되어야 하는 전제조건이 필요합니다.
          </p>
          <p>
            26년 전통과 KNOW HOW 는 고객별 맞춤 설계로 성공적인 파트너가 될 것이며 모두 같이 성장하는 회사가 되도록 노력하겠습니다.
          </p>
          <p>
            물류의 변화에 발맞추지 못하면 작은 회사는 더 작아지게 되는 것이 현실입니다. 유코쉬핑은 이러한 시대의 흐름에 맞추어 크지 않지만 당사만이 가진 특장점을 살려 복합운송업체로 거듭나기 위하여 가장 경쟁력 있는 항공운송 비용과 해상 운송의 경우 FCL은 물론 시장 점유율 최상위 영국 발 해상 컨테이너 GROUPAGE 최저 운임을 바탕으로 표준화된 DOOR TO DOOR 물류 서비스를 고객에게 제공하여 드리고 있습니다.
          </p>
          <p>
            21세기 목표는 창의적 인재와 함께 새로운 가치를 창조하고 빠르게 변화하는 글로발 물류 속에 작은 회사지만 가장 신속하고 저렴하게 물류 산업에 이바지 할 것을 약속 드리며 고객 여러분의 생활을 더욱더 편리하게 해 드릴 것을 약속 드립니다.
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          Client List
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" v-for="(client, ci) in clients" :key="'client-' + ci" class="centre-container">
          <img :src="client.img"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>
            임직원 일동.
          </p>
        </v-col>
      </v-row>
      <div v-if="visitFormItem != false">
        <VisitRequestForm
          :item="visitFormItem"
          :on-close="closeVisitForm">
        </VisitRequestForm>
      </div>
      <div v-if="visitFormItem == false" style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); padding: 10px 30px 10px 30px; background-color: #1976d2; color:white; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px grey; cursor: pointer;" v-on:click="newVisitForm">이사 견적/문의</div>
    </v-container>
</template>

<script>
    import EventBus from "../api/event-bus";
    import VisitRequestForm from "../form/VisitRequestForm";

    export default {
        name: "AboutUs",
        data() {
            return {
                clients: [
                  {
                    img:"/static/img/samsung.png"
                  },
                  {
                    img:"/static/img/lge.jpeg"
                  },
                  {
                    img:"/static/img/hyundai.png"
                  },
                  {
                    img:"/static/img/kia.jpeg"
                  },
                  {
                    img:"/static/img/foreign_depart.jpeg"
                  },
                  {
                    img:"/static/img/hyundai_construction.png"
                  },
                  {
                    img:"/static/img/innocean.png"
                  },
                  {
                    img:"/static/img/kotra.jpg"
                  },
                  {
                    img:"/static/img/woori.png"
                  },
                ],
              visitFormItem: false,
            }
        },
        components: {
          VisitRequestForm,
        },
        created() {
          EventBus.$on('onSubmitted', this.onRequestSubmitted);
        },
        methods: {
          closeVisitForm: function() {
            this.$data.visitFormItem = false;
          },
          newVisitForm: function() {
            this.$data.visitFormItem = {
              id:0,
              requestType:'',
              visitDate:'',
              visitHour:10,
              shippingMode:"",
              requester:"",
              headCount:0,
              phoneNumber:'',
              email:'',
              companyName:'',
              countryFrom:'UK',
              addressFrom:'',
              countryTo:'',
              addressTo:'',
              expectedMoveDate:'',
              state:0,


            }
            if(this.$data.mode >= 100) {
              this.$data.visitFormItem.requestType = 'korea';
              this.$data.visitFormItem.countryTo = '대한민국';
            }
            if(this.$data.mode >= 200) {
              this.$data.visitFormItem.requestType = 'world';
              this.$data.visitFormItem.countryTo = '영국';
            }
            if(this.$data.mode >= 300) {
              this.$data.visitFormItem.requestType = 'uk';
              this.$data.visitFormItem.countryTo = '영국';
            }
          },
          openTnc: function(tnc) {
            EventBus.$emit("tnc", tnc);
          },
          submitRequest: function() {
            console.log("Request to submit");
            console.log(this.$data.visitFormItm);
          },
          onRequestSubmitted: function() {
            // window.alert("감사합니다. 이메일을 확인해주세요");
            this.$data.visitFormItem = false;
          }
        }
    }
</script>

<style scoped>
  .centre-container {
    height: 100px;
    position: relative;
  }
  .centre-container > img {
    position: absolute;
    top:50%;
    left:50%;
    width: 70%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue